import React, { useState } from "react";
import { Menu, Submenu, Item, useContextMenu } from "react-contexify";
import { notify } from "../../generic";
import TvaModal from "./TvaModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCancel, faCog } from "@fortawesome/free-solid-svg-icons";
import { Tooltip } from "react-tippy";
import { compose, graphql } from "react-apollo";
import { splitTransaction } from "../../../api/queries/transactions.mutations";
import Confirm from "../Dialog/Confirm";

function TvaButton({
  fournisseurs,
  transaction,
  updateFrequenceAction,
  utilisateurId,
  entreprise,
  refetchAction,
  addedFournisseurs = [],
  selectedFournisseur = {},
  splitTransactionMutation,
  updateTransaction,
  refetchAction: refetch
}) {
  const [buttonActive, setButtonActive] = useState(false); // correspond à un identfiant de compte, sinon null
  const [tvaModalOpen, setTvaModalOpen] = useState(false);
  const [unsplitDialogOpen, setUnsplitDialogOpen] = useState(false); // correspond à un identfiant de compte, sinon null
  const {
    frequence,
    id: transactionId,
    splitted,
    montant,
    tva: currentTva
  } = transaction;
  let { fournisseur } = transaction;
  if (selectedFournisseur.value) fournisseur = selectedFournisseur;

  const handleItemClick = ({ data }) => {
    return updateTransaction({
      utilisateurId,
      tva: parseFloat(data),
      montant: parseFloat(transaction.montant),
      transactionId,
      refetch
    });
  };
  const handleSplitTransaction = ({ event, unsplit = false }) => {
    try {
      return splitTransactionMutation({
        variables: {
          utilisateurId,
          transactionId,
          unsplit
        }
      }).then(({ data }) => {
        const { type, message, details } = data.splitTransaction;

        if (type === "success") {
          refetch();
          notify("success", message);
        } else {
          notify("error", message);
        }
      });
    } catch (error) {
      notify("error", error.message);
    }
  };

  const MENU_ID = `menu-tva-${transactionId}`;

  const { show } = useContextMenu({
    id: MENU_ID
  });

  const items = [
    { tva: "20", label: "20%" },
    { tva: "10", label: "10%" },
    { tva: "5.5", label: "5,5%" }
  ];

  const displayMenu = e => {
    // put whatever custom logic you need
    // you can even decide to not display the Menu
    show(e, {
      position: {
        x: e.pageX - 10,
        y: e.pageY
      }
    });
    setButtonActive(true);
  };

  const handleContextMenuAction = e => {
    handleItemClick({
      ...e,
      addedFournisseurs,
      selectedFournisseur,
      fournisseurs
    });
  };

  let renderedTvaButton = (
    <Item
      data="unique"
      style={{ textAlign: "right" }}
      onClick={event => handleSplitTransaction({ event, unsplit: false })}
    >
      <FontAwesomeIcon icon={faCog} size={"xs"} color="gray" />
      &nbsp;Répartir la tva {splitted}
    </Item>
  );

  if (splitted)
    renderedTvaButton = (
      <Item
        data="unique"
        style={{ textAlign: "right" }}
        onClick={event => setUnsplitDialogOpen(true)}
      >
        <FontAwesomeIcon icon={faCancel} size={"xs"} color="gray" />
        &nbsp;Annuler la répartition
      </Item>
    );

  if (transaction.parent) renderedTvaButton = null;

  const menu = (
    <Menu id={MENU_ID} onHidden={() => setButtonActive(false)}>
      <Item disabled>Appliquer une TVA</Item>

      {items.map(({ tva, label }) => (
        <Item data={tva} onClick={e => handleContextMenuAction(e)}>
          {label}
        </Item>
      ))}
      <Item data="custom" onClick={e => setTvaModalOpen(true)}>
        Autre...
      </Item>
      {renderedTvaButton}
    </Menu>
  );

  const colTva = ["colTva"];

  return (
    <>
      <TvaModal
        open={tvaModalOpen}
        setOpen={setTvaModalOpen}
        callback={data => handleItemClick({ data })}
      />
      <Confirm
        open={unsplitDialogOpen}
        setOpen={setUnsplitDialogOpen}
        variables={{
          transactionId,
          utilisateurId
        }}
        caption={`Voulez-vous vraiment annuler la répartition de la transaction ?`}
        onSubmitAction={() => handleSplitTransaction({ unsplit: true })}
        notify={false}
      />
      <div className={colTva.join(" ")} onClick={displayMenu}>
        <Tooltip
          // options
          title="Modifier la TVA"
          position="bottom"
          size="small"
        >
          <span>{currentTva ? `${currentTva} %` : "TVA"}</span>
        </Tooltip>
      </div>
      {menu}
    </>
  );
}

export default compose(
  graphql(splitTransaction, {
    name: "splitTransactionMutation"
  })
)(TvaButton);
